<style>
.header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
  left: unset !important;
  right: 15px !important;
  margin-top: -5px;
}
.app-version-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-family: 'SF Mono', Menlo, Consolas, monospace;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #ffffff;
  background: linear-gradient(135deg, #3597ef 0%, #5cb3f4 100%);
  padding: 6px 14px;
  border-radius: 6px;
  margin-left: 14px;
  direction: ltr;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 2px 6px rgba(53,151,239,0.35), inset 0 1px 0 rgba(255,255,255,0.2);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  line-height: 1.2;
}
.app-version-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(53,151,239,0.45), inset 0 1px 0 rgba(255,255,255,0.2);
}

/* Changelog Modal */
.changelog-modal .modal-content {
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
}
.changelog-modal .modal-header {
  background: linear-gradient(135deg, #3597ef 0%, #5cb3f4 100%);
  color: #fff;
  border: none;
  padding: 22px 64px 18px 26px;
  position: relative;
}
.changelog-modal .modal-header .close,
.changelog-modal .modal-header .close:hover,
.changelog-modal .modal-header .close:focus,
.changelog-modal .modal-header .close:active {
  color: #fff !important;
  text-shadow: none !important;
  opacity: 1 !important;
  font-size: 1.4rem !important;
  line-height: 1 !important;
  position: absolute !important;
  top: 16px !important;
  right: 18px !important;
  left: auto !important;
  bottom: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  min-height: 32px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  box-shadow: none !important;
  outline: none !important;
  transform: none !important;
  transition: background-color 0.15s ease !important;
  box-sizing: border-box !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}
.changelog-modal .modal-header .close {
  background: rgba(255, 255, 255, 0.18) !important;
}
.changelog-modal .modal-header .close:hover {
  background: rgba(255, 255, 255, 0.35) !important;
}
.changelog-modal .ch-title { font-size: 1.15rem; font-weight: 700; margin: 0; line-height: 1.2; }
.changelog-modal .ch-subtitle {
  font-size: 0.78rem;
  opacity: 0.88;
  margin-top: 4px;
  font-family: 'SF Mono', Menlo, monospace;
  letter-spacing: 0.3px;
}
.changelog-modal .modal-body { padding: 22px 26px; background: #fff; }
.changelog-modal .ch-section-title {
  font-size: 0.78rem;
  font-weight: 700;
  color: #6e6b7b;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 14px;
  display: flex; align-items: center; gap: 6px;
}
.changelog-modal .ch-list { list-style: none; padding: 0; margin: 0; }
.changelog-modal .ch-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 11px 0;
  border-bottom: 1px solid #f3f2f7;
  font-size: 0.92rem;
  color: #4b4b5a;
  line-height: 1.55;
}
.changelog-modal .ch-item:last-child { border-bottom: none; }
.changelog-modal .ch-tag {
  flex-shrink: 0;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  margin-top: 2px;
  letter-spacing: 0.3px;
  font-family: 'SF Mono', Menlo, monospace;
}
.changelog-modal .ch-tag.new      { background: #e0f5e9; color: #28c76f; }
.changelog-modal .ch-tag.fix      { background: #fdecec; color: #ea5455; }
.changelog-modal .ch-tag.improve  { background: #e3f2fd; color: #3597ef; }
.changelog-modal .ch-preview {
  margin-top: 8px;
  padding: 10px 14px;
  background: #f8f9fc;
  border-radius: 6px;
  border-right: 3px solid #3597ef;
  font-size: 0.85rem;
}
.changelog-modal .ch-preview-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
}
.changelog-modal .ch-preview-row strong { color: #4b4b5a; min-width: 75px; }
.changelog-modal .ch-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.78rem;
  font-weight: 600;
}
.changelog-modal .ch-badge.ch-sat { background: #e6f7ed; color: #186b3a; }
.changelog-modal .ch-badge.ch-bat { background: #e6f7ed; color: #186b3a; }
.changelog-modal .modal-footer {
  border: none;
  background: #fafafa;
  padding: 12px 26px;
  font-size: 0.78rem;
  color: #b9b9c3;
  justify-content: space-between;
}
.app-version-badge::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 5px rgba(255,255,255,0.9), 0 0 0 2px rgba(255,255,255,0.3);
  animation: pulse-dot 1.8s ease-in-out infinite;
  flex-shrink: 0;
}
@keyframes pulse-dot {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%      { opacity: 0.7; transform: scale(0.85); }
}
</style>
<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <div>
      <ul class="nav navbar-nav d-none">
        <li class="nav-item">
          <b-link
            class="nav-link"
            @click="toggleVerticalMenuActive"
          >
            <feather-icon
              icon="MenuIcon"
              size="21"
            />
          </b-link>
        </li>
      </ul>
    </div>
    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1  d-lg-flex">
      <!--<dark-Toggler class="d-none d-lg-block" />
      <span class="ml-50 locale-link"> | </span>-->
      <Bookmarks class=" d-lg-flex" />
      <span
        class="app-version-badge d-none d-md-inline-flex"
        :title="`مشاهده تغییرات نسخه ${appVersion}`"
        @click="showChangelog = true"
      >
        v{{ appVersion }}
      </span>

      <b-modal
        v-model="showChangelog"
        modal-class="changelog-modal"
        hide-header
        hide-footer
        centered
        size="md"
        body-class="p-0"
      >
        <div class="modal-header">
          <button
            type="button"
            class="close"
            aria-label="بستن"
            @click="showChangelog = false"
          >&times;</button>
          <div>
            <h5 class="ch-title">تغییرات این نسخه</h5>
            <div class="ch-subtitle">v{{ appVersion }} • Build {{ appBuild }}</div>
          </div>
        </div>

        <div class="modal-body">
          <div class="ch-section-title">
            <feather-icon icon="ZapIcon" size="14" /> آنچه در این نسخه تغییر کرده
          </div>
          <ul class="ch-list">
            <li class="ch-item">
              <span class="ch-tag fix">رفع باگ</span>
              <span>رفع برخی از مشکلات گزارش‌شده توسط کاربران</span>
            </li>
            <li class="ch-item">
              <span class="ch-tag improve">بهبود</span>
              <span>اصلاح نمایش «آخرین گزارش» — حالا زمان دقیق آخرین تماس دستگاه با سرور نشان داده می‌شود</span>
            </li>
            <li class="ch-item">
              <span class="ch-tag new">قابلیت جدید</span>
              <span>نمایش وضعیت ماشین در پنجره دستگاه (پارک کرده، در حال حرکت، موتور روشن) به همراه مدت زمان</span>
            </li>
            <li class="ch-item">
              <span class="ch-tag improve">بهبود</span>
              <span>به‌روزرسانی خودکار وضعیت دستگاه‌ها حتی در شرایطی که اتصال زنده موقتاً قطع شده باشد</span>
            </li>
            <li class="ch-item">
              <span class="ch-tag new">قابلیت جدید</span>
              <span>
                نمایش <strong>کیفیت GPS</strong> و <strong>وضعیت باتری</strong> در پنجره دستگاه. مثلاً:
                <div class="ch-preview">
                  <div class="ch-preview-row"><strong>کیفیت GPS:</strong><span class="ch-badge ch-sat">موقعیت بسیار دقیق (10 از 12 ماهواره)</span></div>
                  <div class="ch-preview-row"><strong>باتری:</strong><span class="ch-badge ch-bat">عالی ⚡</span></div>
                </div>
              </span>
            </li>
            <li class="ch-item">
              <span class="ch-tag new">قابلیت جدید</span>
              <span>دکمه «کپی مختصات» و «مشاهده در گوگل مپ» در پنجره هر دستگاه</span>
            </li>
            <li class="ch-item">
              <span class="ch-tag new">قابلیت جدید</span>
              <span>نمایش نسخه برنامه در نوار بالا و دسترسی به تغییرات با یک کلیک</span>
            </li>
          </ul>
        </div>

        <div class="modal-footer">
          <span>تاریخ انتشار: {{ buildDate }}</span>
          <b-button
            size="sm"
            variant="primary"
            @click="showChangelog = false"
          >
            متوجه شدم
          </b-button>
        </div>
      </b-modal>
    </div>
    <AdminDrop
      class="d-lg-block"
      style=""
    />
    <b-navbar-nav class="nav align-items-center ml-auto">
      <!--<Locale class="d-lg-block" />-->
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link "
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ fullname }}
            </p>
            <span class="user-status" />
          </div>
          <b-avatar
            size="40"
            variant="primary"
            badge
            :text="avatarText(user.name)+avatarText(user.family)"
            class="badge-minimal"
            badge-variant="success"
          />
          <!--  :src="require('@/assets/images/avatars/6-small.png')" -->
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.native="$router.push({name:'profile'})"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>{{ $t('Profile') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.native="$router.push({name:'subscription-renew'})"
        >
          <feather-icon
            size="16"
            icon="RefreshCwIcon"
            class="mr-50"
          />
          <span>تمدید اشتراک</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.native="$router.push({name:'payment-transactions'})"
        >
          <feather-icon
            size="16"
            icon="ListIcon"
            class="mr-50"
          />
          <span>تراکنش‌های من</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>{{ $t('Inbox') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.native="$router.push({name:'set-password'})"
        >
          <feather-icon
            size="16"
            icon="LockIcon"
            class="mr-50"
          />
          <span>تنظیم رمز عبور</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click.prevent="logOut"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>{{ $t('Logout') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BModal, BButton,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import Bookmarks from '@core/layouts/components/app-navbar/components/Bookmarks.vue'
import AdminDrop from '@core/layouts/components/app-navbar/components/AdminDrop.vue'
import { avatarText } from '@core/utils/filter'
import { getUserData } from '@/auth/utils'
import { APP_VERSION, APP_BUILD } from '@/version'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BModal,
    BButton,
    Locale,
    Bookmarks,
    AdminDrop,
    // Navbar Components
    // eslint-disable-next-line vue/no-unused-components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      user: getUserData(),
      fullname: `${getUserData().name} ${getUserData().family}`,
      avatarText,
      appVersion: APP_VERSION,
      appBuild: APP_BUILD,
      showChangelog: false,
      buildDate: '۲۶ خرداد ۱۴۰۵',
    }
  },
  methods: {
    logOut() {
      if (confirm('آیا مطمئن هستید؟')) {
        this.$store.dispatch('auth/logout')

        this.$router.push('/login')
      }
    },
  },
}
</script>
